import {Action, Selector, State, StateContext} from "@ngxs/store";
import {Session} from "@app/app.session";
import {DecisionsService} from "@app/services/decisions.service";
import {DecisionRequest} from "@app/models/decision-request.model";
import {tap} from "rxjs/operators";
import {ReassignDecisionToModel} from "@app/models/reassign-decision-to.model";
import {Observable} from "rxjs";

export class DecisionsStateModel {
  allAnswered:boolean;
}

export class SaveDecisions {
  static readonly type = '[decisions] SaveDecisions';
  constructor (public decisionRequest:DecisionRequest) {}
}

export class SetDecision{
  static readonly type = '[decisions] SetDecision';
  constructor (public value:boolean) {}
}

export class AssignToDecision{
  static readonly type = '[decisions] AssignToDecision';
  constructor (public value:ReassignDecisionToModel) {}
}

export class ReassignDecision{
  static readonly type = '[decisions] ReassignDecision';
  constructor (public value:ReassignDecisionToModel) {}
}

@State<DecisionsStateModel>({
  name: 'decisions',
  defaults: {
    allAnswered: false
  }
})
export class DecisionsState{

  private static decisionsService: DecisionsService;

  constructor(private decisionsService:DecisionsService, private session:Session) {
    DecisionsState.decisionsService = decisionsService;
  }

  @Selector()
  public static allAnswered(state: DecisionsStateModel){
    return state.allAnswered;
  }

  @Action(SaveDecisions)
  saveDecisions(ctx: StateContext<DecisionsStateModel>, action: SaveDecisions){
    return this.decisionsService.save(action.decisionRequest).pipe(
      tap(res => {
        ctx.patchState({allAnswered: res});
      })
    );
  }

  @Action(SetDecision)
  setDecision(ctx:StateContext<DecisionsStateModel>, action: SetDecision){
    ctx.patchState({allAnswered: action.value});
  }

  @Action(ReassignDecision)
  reassign(ctx:StateContext<DecisionsStateModel>, action: ReassignDecision) : Observable<any>{
    return this.decisionsService.reassign(action.value);
  }

  @Action(AssignToDecision)
  assignTo(ctx:StateContext<DecisionsStateModel>, action: AssignToDecision) : Observable<any>{
    return this.decisionsService.assignTo(action.value);
  }

}
